import { InputNumber, Tooltip } from "antd";
import { bool, object } from "prop-types";
import { DynamicFormItem } from "./DynamicFormItem";
import { useCheckEditableFormField } from "./hooks/useCheckEditableFormField";

import { useIntl } from "react-intl";

export const DynamicInputNumber = ({
  formField,
  formField: {
    property,
    property: { min, max, name, precision },
  },
  formDisabled,
}) => {
  const { isDisabled } = useCheckEditableFormField(formField);
  const intl = useIntl();
  let tooltip = null;

  if (min && max) {
    tooltip = intl.formatMessage(
      { id: "projectIntake.tooltips.minMax" },
      { min, max }
    );
  } else if (min) {
    tooltip = intl.formatMessage({ id: "projectIntake.tooltips.min" }, { min });
  } else if (max) {
    tooltip = intl.formatMessage({ id: "projectIntake.tooltips.max" }, { max });
  }

  return (
    <Tooltip title={tooltip} style={{ display: tooltip ? "block" : "hidden" }}>
      <DynamicFormItem formFieldProperty={property}>
        <InputNumber
          data-test-id={`dynamic-input-number-${name}`}
          disabled={formDisabled || isDisabled}
          min={min}
          max={max}
          precision={precision}
        />
      </DynamicFormItem>
    </Tooltip>
  );
};

DynamicInputNumber.propTypes = {
  formField: object.isRequired,
  formDisabled: bool,
};
